import { ProductUid } from '../../domain/models/related-products.models';

import { ProductPublicModels } from '@features/products/product';

export const findProductUidOnProductArrayUseCase = (
    productArray: ProductPublicModels.PublicProduct[],
    productUid: ProductUid
): ProductPublicModels.PublicProduct => {
    return productArray.find((prod) => prod?.id === productUid?.mocaId
        || prod?.id === productUid?.product_id || prod?.moca === productUid?.uid?.slice(1));
};
